module.exports = __webpack_public_path__ + "img/sntomas estrangulamento 2.e6c077ff.webp";